// General questions for the homepage and contact page.
//
// Service-specific and city-specific questions live with their own data, in
// services.js and locations.js, so no page ever repeats another page's FAQ
// block. Duplicated FAQ content across a site is both dull to read and, where
// it's marked up as structured data, actively unhelpful.
//
// Every answer here is consistent with what the business already states.
// Nothing commits to a response time, a warranty length, a payment schedule or
// a licence number — none of those have been confirmed, and an FAQ is exactly
// where an invented commitment does the most damage.

export const GENERAL_FAQS = [
  {
    question: "What areas do you cover?",
    answer:
      "We're based in Pickering and most of our work is in Pickering, Ajax and Whitby, with projects in Oshawa and west toward Scarborough and Toronto as well. Further out in Durham Region is possible depending on the size of the job and our schedule — worth asking rather than assuming.",
  },
  {
    question: "Is the quote free?",
    answer:
      "Yes. We come out, walk the space with you, and give you a written scope and price. There's no charge for the visit or the quote.",
  },
  {
    question: "Do you handle permits?",
    answer:
      "Where a project needs one, yes — we make the application to your municipality and coordinate the inspections as part of the job. On legal basement conversions in particular, that's a substantial part of the work.",
  },
  {
    question: "Can we live in the house while you work?",
    answer:
      "Usually, and most of our clients do. Dust containment goes up before demolition starts and stays up, floors get protected, and the site is tidied at the end of the day. We'll be straight with you about the stretches that are genuinely disruptive — a kitchen without a working sink, for instance — so you can plan around them.",
  },
  {
    question: "Do you use subcontractors?",
    answer:
      "We self-perform most trades — framing, drywall, tile, flooring, painting and finish carpentry. Licensed electrical and plumbing work is brought in where it's required. That mix is why the finished details line up, and why there's one person accountable for the project rather than a chain of companies.",
  },
  {
    question: "How much does a renovation cost?",
    answer:
      "Genuinely depends on scope, and anyone quoting a figure before seeing the space is guessing. A single-room refresh and a full gut with layout changes are different projects by an order of magnitude. Tell us roughly what you're thinking and what you'd like to spend, and we'll tell you honestly whether those two things meet.",
  },
];
